<template>
  <div class="ch-widget ch-highlights mb-6 mx-auto">
    <v-subheader v-if="! hideTitle" class="text-overline primary--text">Highlights</v-subheader>
    <v-list dense three-line class="grey lighten-4 v-list--striped py-0 ch-highlights__list" min-height="420">
      <v-list-item v-for="(item, i) in items" :key="i" :href="item.link">
  <!--       <v-list-item-avatar>
          <v-icon small color="primary">mdi-record</v-icon>
        </v-list-item-avatar> -->
        <v-list-item-content>
          <v-list-item-subtitle v-html="item.title" class="secondary-X-text"></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
  export default {
    name: 'HighlightsWidget',

    data: () => ({
      items: []
    }),

    props: {
      excludedIds: {
        type: Array,
        default: () => ([])
      },
      hideTitle: {
        type: Boolean,
        default: false
      },
      perPage: {
        type: Number,
        default: 10
      }
    },

    methods: {
      getHighlightPosts() {
        this.$axios.get('/wp-json/wp/v2/posts?exclude=' + this.excludedIds + '&categories=7,3106&per_page=' + this.perPage) // + '&_embed=1')
        // this.$axios.get('/wp-json/wp/v2/posts?exclude=' + this.excludedIds + '&filter[category_name]=' + category + '&filter[orderby]=date&order=desc&per_page=10')
        .then(response => {
          this.items = response.data
        })
      },
      handleExcerpt(post) {
        return post.post_excerpt ? post.post_excerpt : post.post_content.substr(0, 300)
      }
    },

    mounted() {
      this.getHighlightPosts()
    }
  }
</script>

<style lang="sass">
  .ch-highlights__list
    &.v-list--two-line .v-list-item, .v-list-item--two-line
      min-height: 48px
    &.v-list--three-line .v-list-item, .v-list-item--three-line
      min-height: 64px
    &.v-list--three-line .v-list-item .v-list-item__subtitle,
    &.v-list-item--three-line .v-list-item__subtitle
      -webkit-line-clamp: 3

  .ch-widget.ch-highlights
    max-width: 300px
  .ch-hero .ch-widget.ch-highlights
    max-width: 100%
</style>
